import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/assets";
import { useLanguage } from "../../lib/i18n";

export const FloatingWhatsApp = () => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t("wa.msg"))}`;

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="floating-whatsapp"
          href={href}
          target="_blank"
          rel="noreferrer"
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          whileHover={{ scale: 1.04 }}
          className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2.5 pl-4 pr-5 py-3.5 rounded-full bg-[--gold] text-[#14180E] font-mono text-[11px] uppercase tracking-[0.16em] shadow-lg shadow-black/40 hover:bg-[--text] transition-colors duration-400"
        >
          <MessageCircle size={18} strokeWidth={2} />
          {t("wa.label")}
        </motion.a>
      )}
    </AnimatePresence>
  );
};
